import ReactDOM from 'react-dom';
import * as ReactDOMNamespace from 'react-dom';

function findDOMNode(componentOrElement) {
  if (componentOrElement == null) {
    return null;
  }

  if (componentOrElement instanceof Element || componentOrElement instanceof Text) {
    return componentOrElement;
  }

  const refHost = componentOrElement;
  if (refHost.current != null) {
    return findDOMNode(refHost.current);
  }

  const instance = componentOrElement;
  let fiber = instance._reactInternals ?? instance._reactInternalFiber;

  while (fiber) {
    const { stateNode } = fiber;
    if (stateNode instanceof Element || stateNode instanceof Text) {
      return stateNode;
    }
    fiber = fiber.child || fiber.sibling;
  }

  return null;
}

/**
 * React 19 removed ReactDOM.findDOMNode. Legacy dependencies (e.g. react-transition-group
 * used by @sbx/sbx-ui-components Banner/Login dropdowns) still call it when this app runs
 * standalone outside the Hive shell.
 *
 * We only mutate the default import (the CJS module.exports object, which is a plain
 * mutable object) and the namespace's own `default` slot. We deliberately avoid writing
 * to the namespace binding itself — Vite/esbuild treats `import * as ns` as strict ESM
 * and refuses to compile `ns.foo = ...` assignments.
 */
export function applyReactDomFindDomNodePolyfill() {
  if (typeof ReactDOM.findDOMNode === 'function') {
    return;
  }

  ReactDOM.findDOMNode = findDOMNode;

  const nsDefault = ReactDOMNamespace.default;
  if (nsDefault && typeof nsDefault.findDOMNode !== 'function') {
    nsDefault.findDOMNode = findDOMNode;
  }
}

applyReactDomFindDomNodePolyfill();
